import clsx from 'clsx'

import './OrderFormCheckbox.css'

export default function OrderFormCheckbox({
  label,
  value,
  disabled = false,
  onUpdate
}) {
  return (
    <div
      className={clsx('order-form-checkbox-container noselect', { disabled })}
      onMouseDown={e => e.stopPropagation()}
      onClick={() => !disabled && onUpdate()}
    >
      <div className={clsx('checkbox', { checked: value })} />
      <span className="checkbox-label">{label}</span>
    </div>
  )
}
